// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Document_wrapper__3jEc1","title":"Document_title__2k5vo"};